import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChartMetricItem } from '../chart-metric-item';
import { useChartHeaderState } from '../hooks';
import { MetricsContainer } from '../styled';
import { getMetricDisplayConfig } from '../utils';

type MetricConfig =
  | {
      key: string;
      labelKey: 'chart.header.currentPnL';
      tooltipKey: 'chart.header.tooltip.currentPnL';
      value: number;
      configType: 'pnl';
    }
  | {
      key: string;
      labelKey: 'chart.header.equity';
      tooltipKey: 'chart.header.tooltip.equity';
      value: number;
      configType: 'equity';
    }
  | {
      key: string;
      labelKey: 'chart.header.closedBalance';
      tooltipKey: 'chart.header.tooltip.closedBalance';
      value: number;
      configType: 'balance';
    };

export const ChartMetrics: FC = () => {
  const { t } = useTranslation('performanceChart');
  const { chartHeaderData, theme } = useChartHeaderState();

  const pnlMetric: MetricConfig = {
    key: 'currentPnL',
    labelKey: 'chart.header.currentPnL',
    tooltipKey: 'chart.header.tooltip.currentPnL',
    value: chartHeaderData.currentPnL,
    configType: 'pnl',
  };

  const otherMetrics: MetricConfig[] = [
    {
      key: 'equity',
      labelKey: 'chart.header.equity',
      tooltipKey: 'chart.header.tooltip.equity',
      value: chartHeaderData.equity,
      configType: 'equity',
    },
    {
      key: 'closedBalance',
      labelKey: 'chart.header.closedBalance',
      tooltipKey: 'chart.header.tooltip.closedBalance',
      value: chartHeaderData.closedBalance,
      configType: 'balance',
    },
  ];

  const allMetrics: MetricConfig[] = [pnlMetric, ...otherMetrics];

  const renderMetric = (metric: MetricConfig) => {
    const config = getMetricDisplayConfig(metric.configType, theme);

    return (
      <ChartMetricItem
        key={metric.key}
        label={t(metric.labelKey)}
        tooltip={t(metric.tooltipKey)}
        value={metric.value}
        textColor={config.textColor}
        textSize={config.textSize}
        labelColor={config.labelColor}
      />
    );
  };

  return (
    <MetricsContainer>
      {allMetrics.map((metric) => renderMetric(metric))}
    </MetricsContainer>
  );
};
